// File: BookKeepingAccountingServices.jsx
import React from "react";

export default function BookKeepingAccountingServices() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Book Keeping and Accounting Services
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks offers comprehensive accounting services aligned with statutory requirements.
          </p>
          <p className="text-gray-700">
            Complete bookkeeping including Tally/QuickBooks maintenance, GST reconciliation, bank reconciliation, financial statement preparation, statutory audits coordination, and tax compliance reporting for businesses across India.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: Accounting bookkeeping services India) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/669611/pexels-photo-669611.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Bookkeeping accounting services financial compliance"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation organization for seamless accounting and compliance.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Books of accounts and ledgers</li>
                <li>Bank statements (last 12 months)</li>
                <li>Tax records (GST, TDS, ITR)</li>
                <li>Invoices, receipts, payment vouchers</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Professional accuracy, regulatory compliance for all bookkeeping and accounting requirements.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Accuracy Guaranteed
                </h3>
                <p className="text-gray-700 text-sm">
                  Precision bookkeeping with 100% bank reconciliation, GST 3B/ITC matching, Tally/QuickBooks implementation, trial balance accuracy, financial ratio analysis, and error-free statutory financial statements preparation.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Complete Regulatory Compliance
                </h3>
                <p className="text-gray-700 text-sm">
                  Full compliance with Companies Act, GST laws, Income Tax Act including monthly GST returns, quarterly TDS returns, annual ITR filing, audit trail maintenance, MCA financial filings, and statutory audit coordination ensuring zero penalties.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Comprehensive Accounting Solutions
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end services from voucher entry, inventory management, payroll processing, cost center accounting, MIS reporting, cash flow analysis, budgeting, financial forecasting, and management accounting advisory with cloud-based real-time access.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
